import React from "react";
import Button from "../../common/Button";

const Indexing = ( props ) => {

  const mapButton = ( value, index ) => {
    return <li key={ index }><Button data-index={ index } className={ props.currentIndex === index ? 'on' : null } onClick={ dispatchIndex }>{ index + 1 }</Button></li>;
  };

  const dispatchIndex = ( event ) => {
    const index = parseInt( event.target.dataset.index );
    props.onClick( index );
    console.log(`***** 오답확인페이지 - ${index+1}번 문제 클릭`)
  };

  const BUTTON = props.data.map( mapButton );

  return (
    <div className="wa-header">
      <div className="wa-header-inner">
        <div className="wa-head">
          <ul>{ BUTTON }</ul>
        </div>
      </div>
    </div>
  );

};

Indexing.defaultProps = {
  data : [],
  currentIndex : 0,
  onClick : () => {}
};

export default Indexing;
